import classNames from 'classnames';
import Link from 'next/link';

import styles from './Breadcrumbs.module.scss';
import { BreadCrumbsMod, BreadCrumbsProps } from './Breadcrumbs.types';

export function Breadcrumbs({
  className,
  links,
  mod = BreadCrumbsMod.Gray,
}: BreadCrumbsProps) {
  return (
    <nav className={classNames(styles.breadcrumbs, styles[mod], className)}>
      <ul className={styles.breadcrumbsList}>
        {links.map((link) => (
          <li className={styles.breadcrumbsItem} key={link.id}>
            {link.href ? (
              <Link className={styles.breadcrumbsLink} href={link.href}>
                {link.title}
              </Link>
            ) : (
              link.title
            )}
          </li>
        ))}
      </ul>
    </nav>
  );
}
